import axios from "axios";

// 🌐 Base URL setup for both local & Render production
const api = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://smarharvest-backend.onrender.com/api/"
      : "https://smarharvest-backend.onrender.com/api/", // 🔹 local dev
  timeout: 15000,
});




// const API_URL = "https://smarharvest-backend.onrender.com/api/users/";

let isRefreshing = false;
let pendingRequests = [];

/** 🔐 Attach access token to all outgoing requests */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/** 🔄 Automatically refresh token on 401 errors */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If no response or not a 401 → reject
    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    // Prevent infinite loop
    if (originalRequest._retry) {
      clearAuth();
      return Promise.reject(error);
    }

    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      clearAuth();
      return Promise.reject(error);
    }

    // Handle concurrent refresh attempts
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingRequests.push({ resolve, reject, originalRequest });
      });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
      // ✅ SimpleJWT refresh endpoint
      const response = await axios.post(
        `${api.defaults.baseURL}users/token/refresh/`,
        { refresh: refreshToken }
      );

      const newAccessToken = response.data.access;
      localStorage.setItem("accessToken", newAccessToken);

      originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

      // Retry any queued requests
      pendingRequests.forEach((req) => {
        req.originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        api(req.originalRequest)
          .then((res) => req.resolve(res))
          .catch((err) => req.reject(err));
      });

      pendingRequests = [];
      isRefreshing = false;

      return api(originalRequest);
    } catch (refreshError) {
      isRefreshing = false;
      pendingRequests.forEach((req) => req.reject(refreshError));
      pendingRequests = [];
      clearAuth();
      return Promise.reject(refreshError);
    }
  }
);

/** 🧹 Clear all authentication data */
export function clearAuth() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
}

export default api;
